import { render, staticRenderFns } from "./OpenSessionsForSerial.vue?vue&type=template&id=254a4f8e"
import script from "./OpenSessionsForSerial.vue?vue&type=script&lang=js"
export * from "./OpenSessionsForSerial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports